import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSparkles = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6 12a5.005 5.005 0 0 0-5-4.99c2.761 0 5-2.243 5-5.01a5.005 5.005 0 0 0 5 4.99c-2.761 0-5 2.243-5 5.01M13 18a5.005 5.005 0 0 0-5-4.99c2.761 0 5-2.243 5-5.01a5.005 5.005 0 0 0 5 4.99c-2.761 0-5 2.243-5 5.01M4 20a4.004 4.004 0 0 0-4-3.993c2.21 0 4-1.794 4-4.007a4.004 4.004 0 0 0 4 3.993c-2.21 0-4 1.794-4 4.007M15 7a3.003 3.003 0 0 0-3-2.994c1.657 0 3-1.346 3-3.006a3.003 3.003 0 0 0 3 2.994c-1.657 0-3 1.346-3 3.006"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSparkles;
